import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";
import type {
  GetAmendmentStatsPayload,
  GetAmendmentStatsResponse,
  GetSearchAuthorsAmendmentsPayload,
  GetSearchAuthorsAmendmentsResponse,
  ReadAmendmentsPayload,
  ReadAmendmentsResponse,
  ReadAmendmentsZoomPayload,
  ReadAmendmentsZoomResponse,
} from "@/commons/types/api/api.types";

/**
 * Fetches author filters from the amendments endpoint.
 * @param {string} name - The name of the author.
 * @returns {Promise<Array>} - A promise that resolves to an array of author filters.
 * @throws {Error} - If there is a network error during the API call.
 */
export const fetchSearchAuthors = async (name: string) => {
  try {
    const response = await httpRequest<
      GetSearchAuthorsAmendmentsResponse,
      GetSearchAuthorsAmendmentsPayload
    >("post", "/amendments/search_authors", {
      name,
    });

    return response.data.personalities ?? [];
  } catch (err) {
    handleNetworkError(err);
    return [];
  }
};

/**
 * Fetch statistics for the amendment list
 * @param payload
 */
export const fetchAmendmentsStats = async (
  payload: GetAmendmentStatsPayload
) => {
  try {
    const response = await httpRequest<
      GetAmendmentStatsResponse,
      GetAmendmentStatsPayload
    >("post", `/amendments-stats`, payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

/**
 * Fetch amendments List
 * @param payload
 */

export const fetchAmendmentsList = async (payload: ReadAmendmentsPayload) => {
  try {
    const response = await httpRequest<
      ReadAmendmentsResponse,
      ReadAmendmentsPayload
    >("post", "/amendments", payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

/**
 * Fetch one Amendment
 * @param amendmentId
 */
export const fetchOneAmendment = async (payload: ReadAmendmentsZoomPayload) => {
  try {
    const response = await httpRequest<
      ReadAmendmentsZoomResponse,
      ReadAmendmentsZoomPayload
    >("post", `/amendments-zoom`, payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

/**
 * Download excel file
 * @param payload
 */
export const downloadExcel = async (payload: ReadAmendmentsPayload) => {
  try {
    const response = await httpRequest<Blob, ReadAmendmentsPayload>(
      "post",
      "/amendments-export",
      payload,
      "blob"
    );
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
